import { render, staticRenderFns } from "./EditTag.vue?vue&type=template&id=23b7f7a8&scoped=true"
import script from "./EditTag.vue?vue&type=script&lang=js"
export * from "./EditTag.vue?vue&type=script&lang=js"
import style0 from "./EditTag.vue?vue&type=style&index=0&id=23b7f7a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b7f7a8",
  null
  
)

export default component.exports